import MenuItemPrice from './MenuItemPrice'

export default MenuItemPrice
